module.exports = __webpack_public_path__ + "static/media/20231026-DSC_4744.276abf38.jpg";